import { useReducer, useEffect } from 'react';
import { checkIfNBA } from '../../../lib/format';

// FIXME: export to shared place
function getPeriodsFromLeague(league) {
  const periods = [];
  const num = league && league.num_periods;
  if (num === undefined) return periods;
  for (let i = 1; i <= num; i++) {
    periods.push({ value: i, label: 'Q' + i });
  }
  periods.push({ value: num + 1, label: 'OT' });
  return periods;
}

const initialState = {
  last2: '',
  periods: [],
  period: [],
  rotation: '',
  timeType: '',
  division: '',
  conference: '',
};

function getInitialState(team) {
  const isNBA = checkIfNBA(team);
  let usableState = Object.assign({}, initialState);
  if (isNBA) return usableState;
  usableState.division = 'In';
  return usableState;
}

function reducer(state, action) {
  return { ...state, [action.type]: action.payload };
}
export function useCombinationsFilter(league, team) {
  const initialState = getInitialState(team);
  const [data, dispatch] = useReducer(reducer, initialState);
  const handleChange = type => payload => dispatch({ type, payload });
  useEffect(() => {
    dispatch({ type: 'periods', payload: getPeriodsFromLeague(league) });
  }, [league]);
  return { data, handleChange };
}
